// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"61625653","239":"cbc4968f","455":"e5a1d909"}[chunkId] + ".chunk.js";
};